import React from 'react';
import Styles from '../assets/css/privacyPolicy.module.scss';
import { FaPlus } from "react-icons/fa6";
import { useNavigate } from 'react-router';

const PrivacyPolicy = () => {
    const navigate = useNavigate();

    const handleIconClick = () => {
        navigate('/signup');
    };

    return (
        <div className={`${Styles.privacy}`}>
            <div className={`${Styles.sub_privacy}`}>
                <h2>Privacy Policy</h2>
                <FaPlus onClick={handleIconClick} />
            </div>
            <div className={`${Styles.privacy_content}`}>
                <h4>Welcome to Mawj Music! Your privacy is important to us. This Privacy Policy outlines how we collect, use, and protect your information when you use our services:</h4>

                <h3>1. Information We Collect</h3>
                <p>We may collect personal information that you provide to us when you create an account, such as your name, email address, and any other information you choose to provide.</p>

                <h3>2. Use of Information</h3>
                <p>We use the information we collect to provide, maintain, and improve our services, communicate with you, and personalize your experience.</p>

                <h3>3. Sharing of Information</h3>
                <p>We do not sell or rent your personal information to third parties. We may share your information with trusted partners who assist us in operating our app, provided they agree to keep this information confidential.</p>

                <h3>4. User Content</h3>
                <p>Any content you upload to our app remains yours. However, by uploading content, you grant us a worldwide, non-exclusive, royalty-free license to use, reproduce, and distribute that content as necessary to provide our services.</p>

                <h3>5. Data Security</h3>
                <p>We take reasonable measures to protect your information from unauthorized access, use, or disclosure. However, no method of transmission over the internet or method of electronic storage is 100% secure.</p>

                <h3>6. Children's Privacy</h3>
                <p>Our services are not intended for children under the age of 13. We do not knowingly collect personal information from children under 13. If we become aware that we have collected such information, we will take steps to delete it.</p>

                <h3>7. Changes to This Privacy Policy</h3>
                <p>We may update this Privacy Policy from time to time. We will notify you of any changes by posting the new policy on this page with an updated effective date.</p>

                <h3>8. Your Rights</h3>
                <p>You have the right to access, correct, or delete your personal information. If you wish to exercise these rights, please contact us using the information below.</p>

                <h3>9. Contact Us</h3>
                <p>If you have any questions about this Privacy Policy, please contact us at mawj@music.com.</p>
 
                <p>Thank you for trusting Mawj Music with your information!</p>
            </div>
        </div>
    )
}

export default PrivacyPolicy
